import { FormalizeCandidate } from '../../models/formalizePayload';
var OverrideCandidateSuspensionController = /** @class */ (function () {
    /*@ngInject*/
    function OverrideCandidateSuspensionController($filter, jobService, alertsAndNotificationsService, MESSAGECONSTANTS) {
        this.$filter = $filter;
        this.jobService = jobService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    OverrideCandidateSuspensionController.prototype.$onInit = function () {
        this.previousJobDetails;
        this.displayHtmlText = "";
        this.loading = false;
        this._setHtmlDisplayText();
        // this.this.getPreviousJobDetails();
        this.setFormalizeActivityPayload();
    };
    OverrideCandidateSuspensionController.prototype._setHtmlDisplayText = function () {
        if (this.type == 'release') {
            this.displayHtmlText = "Candidate '<span class='emerald'>" + this.candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + this.suspendedMonths + "</span>' month(s) of candidate's previous release. ";
            this.displayHtmlText = this.displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(this.releaseDate) + "</span>' from the role '<span class='emerald'>" + this.releasedJobDetails.role + "</span>' ";
            this.displayHtmlText = this.displayHtmlText + "with Requisition Number '<span class='emerald'>" + this.releasedJobDetails.requisitionNumber + "</span>'.";
        }
        else {
            this.displayHtmlText = "Candidate <span class='emerald'>'" + this.candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + this.suspendedMonths + "</span>' month(s) of leaving previous job. ";
            this.displayHtmlText = this.displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(this.releaseDate) + "</span>' from the role '<span class='emerald'>" + this.releasedJobDetails.role + "</span>' ";
            this.displayHtmlText = this.displayHtmlText + "with Requisition Number '<span class='emerald'>" + this.releasedJobDetails.requisitionNumber + "</span>'.";
        }
    };
    OverrideCandidateSuspensionController.prototype.getPreviousJobDetails = function () {
        var _this = this;
        this.loading = true;
        this.jobService.getReleasedCandidateJobDetails(this.candidateId, function (data) {
            _this.previousJobDetails = data[0];
            _this.loading = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    OverrideCandidateSuspensionController.prototype.overrideSuspension = function () {
        this.saveCallback();
    };
    OverrideCandidateSuspensionController.prototype.cancel = function () {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    };
    OverrideCandidateSuspensionController.prototype.receiveFormalizedComment = function (event) {
        this.recruiterDetails.overrideNote = event;
    };
    OverrideCandidateSuspensionController.prototype.onVoiceTranscript = function (transcript) {
        if (this.recruiterDetails.overrideNote) {
            this.recruiterDetails.overrideNote += ' ' + transcript;
        }
        else {
            this.recruiterDetails.overrideNote = transcript;
        }
    };
    OverrideCandidateSuspensionController.prototype.setFormalizeActivityPayload = function () {
        this.formalizeActivityPayload = {
            candidate: new FormalizeCandidate(this.candidateId, this.candidateName, ""),
            requisition: null,
            jobMatch: null,
            company: null
        };
    };
    return OverrideCandidateSuspensionController;
}());
OverrideCandidateSuspensionController.$inject = ['$filter', 'jobService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './override-candidate-suspension.html;
import * as TEMPLATE from 'raw-loader!./override-candidate-suspension.html';
export var OverrideCandidateSuspensionComponent = {
    selector: 'overrideCandidateSuspension',
    component: {
        bindings: {
            candidateId: '@',
            candidateName: '@',
            releaseDate: '<',
            suspendedMonths: '<',
            allowOverride: '<',
            releasedJobDetails: '<',
            recruiterDetails: '=',
            type: '<',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: OverrideCandidateSuspensionController,
        // templateUrl: 'app/shared/overrideCandidateSuspension/override-candidate-suspension.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=override-candidate-suspension.component.js.map